const tenantList = [
  {
    appKey: 'WX_MINI_JBH',
    eventKey: 'J80A84ZBBA40PW1',
    name: '进博会上海会议活动',
    color: '#4174c7',
  },
  {
    appKey: 'WX_MINI_HSCH',
    eventKey: 'L2NDQT6NKJZ1OKU',
    name: '华商出海',
    color: '#293AA2',
  },
  {
    appKey: 'WX_MINI_ZGHZ',
    eventKey: 'ZGHZ',
    name: '中国会展',
    color: '#B00003',
  },
  {
    appKey: 'WX_MINI_WEMEET',
    eventKey: 'WeMeet',
    name: 'WeMeet',
    color: '#00C4C9',
  },
  {
    appKey: 'WX_MINI_HHXQ',
    eventKey: 'HHXQ',
    name: '钬花星球',
    color: '#FF9933',
  },
  {
    appKey: 'WX_MINI_GDC',
    eventKey: 'GDC',
    name: 'GDPS',
    color: '#00A0FF',
  },
  {
    appKey: 'WX_MINI_YQ',
    eventKey: 'YQHUINENGAI',
    name: '荟能',
    color: '#2e7bb4',
  },
  {
    appKey: 'WX_MINI_ZJXZ',
    eventKey: 'ZJXZ',
    name: '张江人工智能创新小镇',
    color: '#2e7bb4',
  },
]

export default function useTenant() {
  function getTenantOptions(key) {
    return tenantList.map((tenant) => ({
      label: tenant.name,
      value: tenant[key],
    }))
  }

  function getTenantByKey(key, value) {
    return tenantList.find((tenant) => tenant[key] === value)
  }

  function getTenantNameByKey(key, value) {
    const tenant = getTenantByKey(key, value)
    return tenant ? tenant.name : ''
  }

  return {
    getTenantOptions,
    getTenantByKey,
    getTenantNameByKey,
  }
}
